const rootEl = document.documentElement;

const init = () => {

	// Event listeners for clicking outside open nav
	window.addEventListener('click', handleClickOutside, false);
	window.addEventListener('touchend', handleClickOutside, false);

	// Loop through nav elements
	for (const el of document.querySelectorAll('[data-nav]')) {

		const navId = el.getAttribute('data-nav');

		for (const trigger of el.querySelectorAll('[data-nav-trigger]')) {

			trigger.addEventListener('click', (e) => {
				handleTriggerClick(navId);
			});
		}
	}

}

const handleTriggerClick = (navId) => {

	handleToggleNav(navId);
}

const handleClickOutside = (e) => {

	// If there is a nav currently open
	if (rootEl.hasAttribute('data-nav-open')) {

		// Get id of open nav
		const openNavId = rootEl.getAttribute('data-nav-open');

		// Check if the click/touch happened inside open nav
		const isClickInside = document.querySelector('[data-nav="' + openNavId + '"]').contains(e.target);

		// If it did not...
		if (!isClickInside) {

			// Close nav
			handleToggleNav(openNavId);
		}
	}
}

const handleToggleNav = (navId) => {

	// Toggle 'nav-open' classes on root el
	rootEl.classList.toggle('nav-open');
	rootEl.classList.toggle('nav-open--' + navId);

	// Toggle data attribute on root el
	if (rootEl.hasAttribute('data-nav-open')) {
		rootEl.removeAttribute('data-nav-open');
	} else {
		rootEl.setAttribute('data-nav-open', navId);
	}
}

export default init;